import TemplateIcon from '@atlaskit/icon-lab/core/template';
import * as React from 'react';

export function SvgWindow() {
  return <TemplateIcon label="" testId="ads-refreshed-icon" />;
}
